export const tokenToNumber = (token: string): number => Number(token.replace('px', ''));
